let sanityConfig = {
  projectId: process.env.GATSBY_SANITY,
  dataset: 'production',
}

export default sanityConfig
